@let loggedInStatus = loggedIn();

<div class="flex container flex--space-between">
  @if (loggedInStatus === LoginStatus.NOT_LOGGED_IN) {
    <fcom-promo-card
      class="fill"
      [theme]="PromoTheme.WHITE"
      [data]="sustainableTravelData()"
      [imageData]="sustainableTravelImage.hasValue() ? sustainableTravelImage.value() : null"
      [ctaData]="sustainableTravelCta()"
      [analyticsEventName]="'sustainableTravel-promotion-banner'"
      [aspectRatio]="'4x3'"
      [fullWidth]="true"
      [interactive]="false"
      [isH2]="true"
    />
  }
  @if (loggedInStatus === LoginStatus.LOGGED_IN) {
    <fcom-promo-card
      class="fill"
      [theme]="PromoTheme.WHITE"
      [data]="donateAviosData()"
      [imageData]="donateAviosImage.hasValue() ? donateAviosImage.value() : null"
      [ctaData]="donateAviosCta()"
      [analyticsEventName]="'donatePoints-promotion-banner'"
      [aspectRatio]="'4x3'"
      [fullWidth]="true"
      [interactive]="false"
      [isH2]="true"
    />
  }
</div>
